import { useState } from "react";
import { apiPost } from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { LoadingBlock } from "@/components/common/StateViews";
import { SeverityChip } from "@/components/common/SeverityChip";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Compass } from "lucide-react";

const EXAMPLES = ["Refactor a large private Python repo", "Draft a customer support reply", "Analyse a 40-page contract for risk", "Summarise last week's sales calls"];

export default function Advisor() {
  const [task, setTask] = useState("");
  const [out, setOut] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async (t) => {
    const q = t || task; if (!q.trim()) return; setTask(q);
    setBusy(true); setOut(null);
    try { setOut(await apiPost("/ai/advisor", { task: q })); } catch { toast.error("Advisor unavailable — check the active LLM engine."); } finally { setBusy(false); }
  };
  return (
    <div>
      <PageHeader eyebrow="Navitra Companion" title="Model & Tool Advisor" subtitle="Describe a task; get the right approved tool, model tier and the reason — with a data-handling caution." />
      <Card className="max-w-2xl">
        <CardContent className="pt-6">
          <Textarea value={task} onChange={(e) => setTask(e.target.value)} placeholder="Describe your task…" className="min-h-[90px]" data-testid="advisor-input" />
          <div className="flex flex-wrap gap-2 mt-3">{EXAMPLES.map((e) => <button key={e} onClick={() => run(e)} className="rounded-full border px-3 py-1 text-xs hover:border-gold/60 transition-colors">{e}</button>)}</div>
          <Button className="mt-3" onClick={() => run()} disabled={busy} data-testid="advisor-run"><Compass className="h-4 w-4 mr-1.5" />{busy ? "Advising…" : "Advise me"}</Button>
          {busy && <LoadingBlock className="h-28 mt-4" />}
          {out && (
            <div className="mt-4 rounded-xl border bg-muted/30 p-4" data-testid="advisor-output">
              <div className="flex items-center gap-2 mb-2"><SeverityChip level="success" label={out.recommended_tool} dot /><SeverityChip level="info" label={out.model_tier} /></div>
              <p className="text-sm">{out.why}</p>
              {out.data_caution && <p className="text-xs text-sev-warning mt-2">⚠ {out.data_caution}</p>}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
